export default "__VITE_ASSET__kfdvVSvO__"